export default "__VITE_ASSET__C3fkk73a__"